import { newWindowCreateCommand } from './v1/create';

export const newWindowCommands = [
  newWindowCreateCommand
];




